


















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { FormRateLunch } from '@/models/config'

// Components
import { FormCreareEditRateLunch } from '@/components/config'

@Component({
    name: 'ModalCreateEditRateLunch',
    components: {
        FormCreareEditRateLunch
    }
})
export default class ModalCreateEditRateLunch extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) rateLunch!: FormRateLunch

    get title () {
        if (this.actionForm === 'save') {
            return 'Crear nueva tarifa de refrigerio'
        }
        return 'Editar tarifa de refrigerio'
    }
}
